export type navItem = {
	aria: string;
	show: string;
	path: string;
	time: number;
	display?: boolean;
};

export const navData: navItem[] = [
	{ "aria": "Before Jesus", "path": "before-jesus", "show": "Before Jesus", "time": -101 },
	{ "aria": "Pontius Pilate", "path": "pontius-pilate", "show": "Pontius Pilate", "time": 1},
	{ "aria": "Paul", "path": "paul", "show": "Paul", "time": 65},
	{ "aria": "Flavius Josephus", "path": "josephus", "show": "Josephus", "time": 94},
	{ "aria": "Pliny the Younger", "path": "pliny-the-younger", "show": "Pliny the Younger", "time": 111},
	{ "aria": "Publius Cornelius Tacitus", "path": "tacitus", "show": "Tacitus", "time": 116},
	{ "aria": "Papias of Hierapolis", "path": "papias", "show": "Papias", "time": 110},
	{ "aria": "Gaius Suetonius Tranquillus", "path": "suetonius", "show": "Suetonius", "time": 121},
	{ "aria": "Polycarp", "path": "polycarp", "show": "Polycarp", "time": 130},
	{ "aria": "Justin Martyr", "path": "justin-martyr", "show": "Justin Martyr", "time": 157},
	{ "aria": "Mara Bar Serapion", "path": "mara-bar-serapion", "show": "Mara Bar Serapion", "time": 160},
	{ "aria": "Ignatius of Antioch", "path": "ignatius", "show": "Ignatius", "time": 150},
	{ "aria": "Irenaeus of Lyons", "path": "irenaeus", "show": "Irenaeus", "time": 180},
	{ "aria": "Gospels", "path": "gospels", "show": "Gospels", "time": 144.1},
	{ "aria": "Prophecies", "path": "prophecies", "show": "Prophecies", "time": 145},
	{ "aria": "Anachronisms", "path": "anachronisms", "show": "Anachronisms", "time": 146},
	{ "aria": "Clement of Rome", "path": "clement", "show": "Clement", "time": 170},
	{ "aria": "Lucian of Samosata", "path": "lucian-of-samosata", "show": "Lucian of Samosata", "time": 160},
	{ "aria": "Celsus", "path": "celsus", "show": "Celsus", "time": 177},
	{ "aria": "Phlegon of Tralles", "path": "phlegon", "show": "Phlegon", "time": 137},
	{ "aria": "Thallus", "path": "thallus", "show": "Thallus", "time": 52},
	{ "aria": "Quintus Septimius Florens Tertullianus", "path": "tertullian", "show": "Tertullian", "time": 197},
	{ "aria": "P52", "path": "p52", "show": "P52", "time": 200},
	{ "aria": "Talmud", "path": "talmud", "show": "Talmud", "time": 230},
	{ "aria": "Eusebius of Caesarea", "path": "eusebius", "show": "Eusebius", "time": 312},
	{ "aria": "Manuscripts", "path": "manuscripts", "show": "Manuscripts", "time": 200.1},
	{ "aria": "Relics", "path": "relics", "show": "Relics", "time": 201},
	{ "aria": "Shroud of Turin", "path": "shroud-of-turin", "show": "Shroud of Turin", "time": 1354},
	{ "aria": "Calendar", "path": "calendar", "show": "Calendar", "time": 1582},
	{ "aria": "Historical-Critical Method", "path": "historical-critical-method", "show": "Historical-Critical Method", "time": 1600},
	{ "aria": "Ron Wyatt", "path": "ron-wyatt", "show": "Ron Wyatt", "time": 1933},
	{ "aria": "Stylometry", "path": "stylometry", "show": "Stylometry", "time": 2017},
	{ "aria": "Marcion of Sinope", "path": "marcion", "show": "Marcion", "time": 144},
	{ "aria": "The Didache", "path": "didache", "show": "Didache", "time": 150},
	{ "aria": "Die for a lie", "path": "die-for-a-lie", "show": "Die For a Lie", "time": 80},
	{ "aria": "Everything", "path": "everything", "show": "Everything", "time": 2026 },
	{ "aria": "Dustin White", "path": "dustin-white", "show": "Dustin White", "time": 2025, display: false },
];